<template>
    <a-modal title="优惠明细" width="700px" v-model:visible="dialogVisible" centered :footer="null">
        <a-row>
            <a-col class="tableItem" :span="3">用户</a-col>
            <a-col class="tableItem" :span="2">头像</a-col>
            <a-col class="tableItem" :span="3">类型</a-col>
            <a-col class="tableItem" :span="2">数量</a-col>
            <a-col class="tableItem" :span="3">价格</a-col>
            <a-col class="tableItem" :span="3">优惠价格</a-col>
            <a-col class="tableItem" :span="1"></a-col>
            <a-col class="tableItem" :span="3">券</a-col>
            <a-col class="tableItem" :span="1"></a-col>
            <a-col class="tableItem" :span="3">合计</a-col>
        </a-row>
        <div class="main">
            <a-row v-for="(item, index) in moneyDetailList" :key="index">
                <a-col class="tableItem" :span="3">
                    <text-ellipsis style="margin-left: 0px;"
                        :text="item.user?item.user.name:'-'"
                        :chinese-ratio="2"
                        :max-length="6"/>
                </a-col>
                <a-col class="tableItem" :span="2">
                    <div class="avatarrel" v-if="item.user">
                        <a-avatar style="line-height: 28px;" :src="item.user.url==null?'':item.user.url">
                            {{item.user.url==null||item.user.url==''?item.user.name.charAt(0):''}}
                        </a-avatar>
                        <img class="ava-vipImg" v-if="item.user.vipType!=0" :src="require(item.user.vipType==1?'@/assets/Image/userInfo/vip.png':'@/assets/Image/userInfo/svip.png')" alt="">
                    </div>
                    <span v-else>-</span>
                </a-col>
                <a-col class="tableItem" :span="3">{{item.typeName}}</a-col>
                <a-col class="tableItem" :span="2">x{{item.num}}</a-col>
                <a-col class="tableItem" :span="3">{{item.price}}</a-col>
                <a-col class="tableItem" :span="3">{{item.realPrice}}</a-col>
                <a-col class="tableItem fh" :span="1">-</a-col>
                <a-col class="tableItem" :span="3">0</a-col>
                <a-col class="tableItem" style="font-size:18px" :span="1">=</a-col>
                <a-col class="tableItem" :span="3">{{(item.realPrice*item.num).toFixed(2)-0}}</a-col>
            </a-row>
        </div>
        <!-- <div class="total">×3</div> -->
        <div class="totalMoney">
            合计：
            <span class="fmoney">￥</span>
            <span class="nowMoney">{{allMoeny}}</span>
        </div>
    </a-modal>
</template>
<script>
export default {
    props:{
        visible:{
            type:Boolean,
            default:false
        },
        moneyDetailList:{
            type:Array,
            default:()=>[]
        }
    },
    model: {
      prop: 'visible'
    },
    data() {
        return {
            dialogVisible: this.visible,
        }
    },
    computed:{
        allMoeny(){
            let sum = 0
            this.moneyDetailList.forEach(item=>{
                sum += (item.realPrice*item.num)
            })
            return sum.toFixed(2)-0
        }
    },
    watch: {
      dialogVisible(value) {
        // console.log('子组件下拉框值发生改变：', this.dialogVisible)
        this.$emit('update:visible', this.dialogVisible)
      },
      visible(value){
        this.dialogVisible = value
      }
    }
}
</script>
<style lang="less" scoped>
.tableItem{
    text-align: center;
    margin-bottom: 15px;
    line-height: 40px;
    color: #999999;
}
.main{
    background: #f4f5f6;
    padding-top: 15px;
    max-height: 300px;
    overflow-y: auto;
    .tableItem{
        color: #333333;
    }
}
.fh{
    font-size: 27px;
    line-height: 40px;
}
.total{
    color: #333333;
    margin-top: 20px;
    text-align: right;
}
.totalMoney{
    // float: right;
    text-align: right;
    margin-top: 10px;
    margin-bottom: 5px;
    .fmoney{
        font-size: 14px;
        color: #ff1e1e;
    }
    .nowMoney{
        font-size: 30px;
        font-weight: 700;
        line-height: 23px;
        color: #ff1e1e;
    }
}

.avatarrel{
    position: relative;
    display: inline-block;
}
.ava-vipImg {
    position: absolute;
    bottom: -8px; /* 进一步增加距离 */
    left: 50%;
    transform: translateX(-50%);
    width: 38px; /* 更宽一些 */
    height: 19px; /* 高度相对较小，形成胶囊形状 */
    border-radius: 5px;
    object-fit: contain;
    z-index: 1;
}
.clear{
    clear: both;
}
</style>